import React, { Suspense, lazy } from 'react';
import ArticlePage from './ArticlePage';
import { ArticleContent, ArticleMeta } from './types';

// Contenu pré-rendu par le serveur pour la page d'arrivée, lu avant le premier
// rendu React : on le garde affiché pendant le chargement du contenu de
// l'article (sinon la page clignoterait à blanc).
const INITIAL =
  typeof document !== 'undefined'
    ? { path: window.location.pathname, html: document.getElementById('root')?.innerHTML ?? '' }
    : null;

const PAGES = new Map<string, React.LazyExoticComponent<React.FC>>();
function pageFor(meta: ArticleMeta) {
  let Page = PAGES.get(meta.slug);
  if (!Page) {
    Page = lazy(() =>
      import(`./content/${meta.slug}`).then((m: { default: ArticleContent }) => ({
        default: () => <ArticlePage meta={meta} content={m.default} />,
      })),
    );
    PAGES.set(meta.slug, Page);
  }
  return Page;
}

// Route d'un article du blog : son contenu est chargé à la demande, pour que
// les 30 articles ne pèsent pas sur le bundle principal.
const ArticleRoute: React.FC<{ meta: ArticleMeta }> = ({ meta }) => {
  const Page = pageFor(meta);
  const fallback =
    INITIAL && INITIAL.path === `/${meta.slug}` && INITIAL.html ? (
      <div style={{ display: 'contents' }} dangerouslySetInnerHTML={{ __html: INITIAL.html }} />
    ) : null;
  return (
    <Suspense fallback={fallback}>
      <Page />
    </Suspense>
  );
};

export default ArticleRoute;
